// Ziyaret kargo takibi için ortak tanımlar.
// Kayıtlar Visits/{visitId}.shipments dizisinde tutulur (stockItems ile aynı desen).

export const SHIPMENT_STATUS = {
  NOT_SENT: 'not_sent',
  SHIPPED: 'shipped',
  DELIVERED: 'delivered',
  RETURNED: 'returned',
};

// Durum sırası akışı temsil eder: verilmedi → kargoda → teslim edildi.
export const SHIPMENT_STATUS_OPTIONS = [
  {
    value: SHIPMENT_STATUS.NOT_SENT,
    label: 'Kargoya Verilmedi',
    shortLabel: 'Verilmedi',
    tone: 'neutral',
  },
  {
    value: SHIPMENT_STATUS.SHIPPED,
    label: 'Kargoya Verildi',
    shortLabel: 'Kargoda',
    tone: 'info',
  },
  {
    value: SHIPMENT_STATUS.DELIVERED,
    label: 'Teslim Edildi',
    shortLabel: 'Teslim',
    tone: 'success',
  },
  {
    value: SHIPMENT_STATUS.RETURNED,
    label: 'İade / Sorunlu',
    shortLabel: 'İade',
    tone: 'danger',
  },
];

export const getShipmentStatus = (status) =>
  SHIPMENT_STATUS_OPTIONS.find((option) => option.value === status) ||
  SHIPMENT_STATUS_OPTIONS[0];

// Kargo firmaları ve takip numarasıyla açılan sorgulama adresleri.
// buildUrl olmayan firmalarda takip numarası yalnızca kopyalanabilir.
export const CARRIERS = [
  {
    value: 'aras',
    label: 'Aras Kargo',
    buildUrl: (code) => `https://www.araskargo.com.tr/tr/cargo-tracking?code=${code}`,
  },
  {
    value: 'yurtici',
    label: 'Yurtiçi Kargo',
    buildUrl: (code) =>
      `https://www.yurticikargo.com/tr/online-servisler/gonderi-sorgula?code=${code}`,
  },
  {
    value: 'mng',
    label: 'MNG Kargo',
    buildUrl: (code) =>
      `https://service.mngkargo.com.tr/interaktif/gonderitakip/?takipno=${code}`,
  },
  {
    value: 'ptt',
    label: 'PTT Kargo',
    buildUrl: (code) => `https://gonderitakip.ptt.gov.tr/Track/Verify?q=${code}`,
  },
  {
    value: 'surat',
    label: 'Sürat Kargo',
    buildUrl: (code) => `https://www.suratkargo.com.tr/KargoTakip/?kargotakipno=${code}`,
  },
  {
    value: 'ups',
    label: 'UPS',
    buildUrl: (code) => `https://www.ups.com/track?tracknum=${code}`,
  },
  {
    value: 'dhl',
    label: 'DHL',
    buildUrl: (code) =>
      `https://www.dhl.com/tr-tr/home/tracking.html?tracking-id=${code}`,
  },
  { value: 'kurye', label: 'Kurye / Elden Teslim', buildUrl: null },
  { value: 'diger', label: 'Diğer', buildUrl: null },
];

export const getCarrier = (value) =>
  CARRIERS.find((carrier) => carrier.value === value) || null;

export const getCarrierLabel = (value) => getCarrier(value)?.label || '';

// Takip numarasının firma sitesindeki sorgulama adresi (yoksa null).
export const getTrackingUrl = (carrierValue, trackingNumber) => {
  const carrier = getCarrier(carrierValue);
  const code = String(trackingNumber || '').trim();
  if (!carrier || !carrier.buildUrl || !code) return null;
  return carrier.buildUrl(encodeURIComponent(code));
};

// Yüklenebilecek ek türleri: kargo fişi, irsaliye, teslim tutanağı vb.
export const SHIPMENT_ALLOWED_FILE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'image/heic',
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export const SHIPMENT_MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB

export const formatFileSize = (bytes) => {
  const size = Number(bytes) || 0;
  if (size === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB'];
  const index = Math.min(Math.floor(Math.log(size) / Math.log(1024)), units.length - 1);
  return `${parseFloat((size / Math.pow(1024, index)).toFixed(1))} ${units[index]}`;
};

// 'yyyy-mm-dd' → '12 Mart 2026'. Boş/bozuk değerlerde null döner.
export const formatShipmentDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

// <input type="date"> için bugünün tarihi (yerel saat dilimine göre)
export const todayInputValue = () => {
  const now = new Date();
  const pad = (n) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
};

// Liste özetindeki sayaçlar
export const summarizeShipments = (shipments = []) => {
  const summary = {
    total: shipments.length,
    [SHIPMENT_STATUS.NOT_SENT]: 0,
    [SHIPMENT_STATUS.SHIPPED]: 0,
    [SHIPMENT_STATUS.DELIVERED]: 0,
    [SHIPMENT_STATUS.RETURNED]: 0,
  };
  shipments.forEach((shipment) => {
    const key = getShipmentStatus(shipment.status).value;
    summary[key] += 1;
  });
  return summary;
};
